import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import type { ProjectLLMContext } from "@domain/project/ProjectContext";

export interface ChatMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
  createdAt: number;
  /** Optional — for messages seeded from an observation. */
  seededFrom?: {
    kind: "observation";
    title: string;
    severity: "info" | "warn" | "risk";
    category: string;
  };
}

export interface ProjectAssistantCallInput {
  ownerUid: string;
  projectId: string;
  context: ProjectLLMContext;
  messages: Array<{ role: "user" | "assistant"; content: string }>;
}

export interface ProjectAssistantCallOutput {
  reply: string;
  model: string;
  inputTokens: number;
  outputTokens: number;
  costUsd: number;
}

export async function callProjectAssistant(
  input: ProjectAssistantCallInput
): Promise<ProjectAssistantCallOutput> {
  const call = httpsCallable<ProjectAssistantCallInput, ProjectAssistantCallOutput>(
    functions,
    "projectAssistant"
  );
  const result = await call(input);
  return result.data;
}
